module.exports = __webpack_public_path__ + "img/preview-upload_2.73ddf3ba.png";